var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"Header"},[_c('router-link',{attrs:{"to":{ name: _vm.$static.RouterNames.Home }}},[_c('Logo',{staticClass:"Header__logo"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }